<div class="mat-tag-container">
  @for (item of value; track item; let i = $index) {
    <div class="mat-tag-item" (click)="select(item)" [class.selected]="selectedValues?.includes(item)">
      <div class="mat-tag-item-name">
        {{ item }}
      </div>
      @if (removable && !disabled) {
        <div class="mat-tag-item-delete-button" (click)="removeItem(item)">
          <i class="remove-icon" [nimbusIcon]="icons.CLOSE_LIGHT"></i>
        </div>
      }
    </div>
  }
</div>
